<template>
    <div class="form-item">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <textarea
            :maxlength="item.textlength || null"
            :value="item.resposta_texto || ''"
            @input="onInput"
        />

        <textarea
            v-if="item.ckinformacoes === 'S'"
            class="doc-info"
            placeholder="Informações complementares"
            :value="item.informacoes || ''"
            @input="onInputInformacoes"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    item: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['update:item']);

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');

function onInput(event) {
    emit('update:item', {
        ...props.item,
        resposta_texto: event.target.value
    });
}

function onInputInformacoes(event) {
    emit('update:item', {
        ...props.item,
        informacoes: event.target.value
    });
}
</script>

<style scoped>
textarea {
    min-height: 100px;
    resize: vertical;
}

.required {
    color: #b00020;
    margin-left: 3px;
}

.doc-info {
    margin-top: 8px;
    min-height: 70px;
}
</style>